<template>
  <div class="kid-age-selector">
    <div class="kid-age-msg">
      Возраст на момент окончания тура
    </div>
    <div class="round-buttons-wrapper round-buttons-wrapper--6">
        <round-button v-for="i in ages"
          bordered
          :active="is_active_age(i)"
          :disabled="is_disabled(i)"
          v-on:click="change_age(i)"
        >
          {{i}}
        </round-button>
    </div>
  </div>
</template>
<script>
  import RoundButton from "./RoundButton";
  export default {
    components: {RoundButton},
    props: ['age', 'min', 'max'],
    data(){
      return {
        ages: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
        localAge: this.age,
      }
    },
    methods: {
      is_active_age(n){
        return (n === this.localAge);
      },
      is_disabled(n){
        return ((this.min !== undefined) && (n < this.min));
      },
      change_age(index){
        // console.log('click');
        if (!this.is_disabled(index)) {
          this.$set(this, 'localAge', index);
          this.$emit('change', index);
        }
      },
      say: function (message) {
        // console.log(message);
      }
    },
  }
</script>